import { render, staticRenderFns } from "./shopEdit.vue?vue&type=template&id=64c851f8&"
import script from "./shopEdit.vue?vue&type=script&lang=js&"
export * from "./shopEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports